export const smokyBlack =  "#0a0903ff";
export const vanilla =  "#fff3b0ff";
export const phthaloBlue =  "#020887ff";
export const cadetGray =  "#8aa1b1ff";
export const electricBlue =  "#87f6ffff";
export const black =  "#000";
